import initialState from './initialState';

export default function mainReducer(state = initialState.main, action) {
  switch (action.type) {
    case "REQUEST_ERROR": {
      return {
        ...state,
        errors: [action.value]
      }
    }
    case "REQUEST_LANGUAGES": {
      return {
        ...state,
        languages: action.value
      }
    }
    case "REQUEST_COUNTRIES": {
      return {
        ...state,
        countries: action.value
      }
    }
    case "REQUEST_MUNICIPALITIES": {
      return {
        ...state,
        municipalities: action.value
      }
    }
    case "REQUEST_OFFICES": {
      return {
        ...state,
        offices: action.value
      }
    }
    case "REQUEST_USERS": {
      return {
        ...state,
        users: action.value
      }
    }
    case "REQUEST_COMUNITIES": {
      return {
        ...state,
        comunities: action.value
      }
    }
    case "REQUEST_PROVINCES": {
      return {
        ...state,
        provinces: action.value
      }
    }
    case "REQUEST_CONSULT_TYPES": {
      return {
        ...state,
        consultTypes: action.value
      }
    }
    case "LOGIN": {
      return {
        ...state,
        sessionData: action.value
      }
    }
    case "LOGOUT": {
      return {
        state
      }
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/main.js